// node_modules
import { FC, useContext } from "react";
// Enums
import { CaseActionTypeEnum } from "Enums";
// Interfaces
import { ICaseSelectedTechnology } from "Interfaces";
// Stores
import { CaseContext } from "Stores";
// Types
import { TTechnology } from "Types";
// styles
import styles from "./technologyListItem.module.scss";
// Components
import { TechnologyListItemSideNotes } from "./TechnologyListItemSideNotes";
import { TechnologyListItemRates } from "./TechnologyListItemRates";
import { TechnologyListItemVotes } from "./TechnologyListItemVotes";
// Constants
import { CasePhaseConstants } from "Constants";
import { DeliveryLayoutContext } from "Providers";

type TTechnologyListItemProps = {
    technology: TTechnology
}

export const TechnologyListItem: FC<TTechnologyListItemProps> = ({ technology }: TTechnologyListItemProps) => {
    // Contexts
    const { caseState, caseDispatch } = useContext(CaseContext);
    const { resetScrollCurrentMainScrolledContainer } = useContext(DeliveryLayoutContext);

    // Logic
    const getClassName = (): string => {
        const classNameList = [styles.technologyListItem];
        if(caseState.selectedTechnologyId && caseState.selectedTechnologyId === technology.id) classNameList.push(styles.active);             
        return classNameList.join(" ");
    };

    const handleTechnologyClick = (): void => {
        resetScrollCurrentMainScrolledContainer();
        caseDispatch({ type: CaseActionTypeEnum.SetCaseSelectedTechnology, selectedTechnologyId: technology.id, 
            selectedOriginalTechnologyId: technology.originalTechnologyId, selectedEntityName: technology.name,
            selectedEntityNumbering: technology.numbering} as ICaseSelectedTechnology);
    };

    return (
        <>
            <div className={getClassName()} onClick={handleTechnologyClick}>
                <span className = {styles.technologyTitle} title={technology.name}>{technology.numbering} {technology.name}</span>
                <div style={{display: caseState.casePhase.toLowerCase()=== CasePhaseConstants.PHASE_1.toLowerCase() ? "block" : "none"}}>
                    <TechnologyListItemVotes technology={technology} />
                </div>
                <div style={{display: caseState.casePhase.toLowerCase() === CasePhaseConstants.PHASE_2.toLowerCase() ? "block" : "none"}}>
                    <TechnologyListItemRates technology={technology} />
                </div>
                <TechnologyListItemSideNotes technology={technology} />
            </div>
        </>
    );
};